import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router";
import { Button, Card, Form, Row, Col, Table } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import Select, { SingleValue } from "react-select";
import { themeSelect } from "../../../shared/components/Select2";
import { nanoid } from "nanoid";
export const AddForm = ({
  setCreateField,
  createField,
  submitHandler,
  handleKeyDown,
  contentTitle,
  changeHandler,
  handleFilesInput,
  setContentTitle,
  defaultContentTitle,
  showUpdate,
  removeFormFields,
  addFormFields,
  handleSelectSingleClient,
  clientList,
  setContentId,
  userClientList,
}: any) => {
  const { t } = useTranslation();
  return (
    <>
      {/* <button
          className="btn btn-secondary"
          onClick={() => setCreateField(true)}
        >
          {t("products.data_history")}
        </button> */}
      {!createField && (
        <div className=" ">
          <div className="d-flex align-items-center justify-content-between">
            <h4 className="card-title mg-b-0">
              {t("client_dashboard.data_history_create")}
            </h4>
            <button
              className="btn btn-primary ms-2"
              onClick={() => setCreateField(true)}
            >
              {t("global.add")}
            </button>
          </div>
        </div>
      )}

      {createField && (
        <Form onSubmit={submitHandler} onKeyDown={handleKeyDown}>
          <Row className="d-flex align-items-start my-3">
            <Col md={6}>
              <label htmlFor="name" className="required-field">
                {`${t("global.name")}`}
              </label>
              <input
                type="text"
                name="name"
                placeholder={`${t("mapping.type")}...`}
                className="form-control"
                value={((contentTitle as any)?.name as string) ?? ""}
                required
                onChange={changeHandler}
              />
            </Col>
            <Col md={4} className="mb-2">
              <label htmlFor="client" className="required-field">{`${t(
                "global.client"
              )}`}</label>
              <Select
                className="react-select-field"
                theme={themeSelect}
                key={nanoid()}
                isDisabled={userClientList?.length === 1}
                defaultValue={
                  userClientList?.length === 1
                    ? {
                        label: userClientList[0]?.name as string,
                        value: userClientList[0]?.id as number,
                      }
                    : {
                        label: contentTitle?.client?.name as string,
                        value: contentTitle?.client?.id as number,
                      }
                }
                onChange={(e) => {
                  handleSelectSingleClient(e as any);
                }}
                options={(userClientList as any)?.map((client: any) => ({
                  value: client?.id,
                  label: client?.name,
                }))}
              />
            </Col>
            <div className="mt-2">
              <label>{t("mapping.documents")}</label>
              {contentTitle?.documents?.map((element: any, index: any) => {
                const sliceNumber = element?.path?.split("/")?.length;
                return (
                  <div
                    className="form-inline"
                    key={
                      element?.id
                        ? `file-${element.id}`
                        : `file-${index}-${Date.now()}`
                    }
                    // key={nanoid()}
                  >
                    <Row>
                      <Col md={6}>
                        <div className=" mt-2 mx-auto ">
                          <div>
                            <input
                              name="path"
                              id={index as any}
                              type="file"
                              accept="image/*"
                              // ref={imageRef}
                              className="profile-img-file-input "
                              onChange={(e) =>
                                handleFilesInput(index, e, element)
                              }
                            />
                          </div>
                          <span className="my-2">
                            {" "}
                            {(element?.path && element?.name) ??
                              element?.file?.nameOriginal ??
                              ""}
                          </span>
                        </div>
                      </Col>
                    </Row>
                    {/* {index ? ( */}

                    <div className="row">
                      <div className="col-md-6">
                        <div className="d-flex justify-content-end">
                          <button
                            type="button"
                            className="btn btn-danger  my-2"
                            onClick={() =>
                              removeFormFields(index, element?.id, element)
                            }
                          >
                            {t("global.remove")}
                          </button>
                          {index == contentTitle?.documents?.length - 1 && (
                            <button
                              className="btn btn-success my-2 ms-2"
                              type="submit"
                              onClick={() => {
                                addFormFields();
                              }}
                            >
                              {t("global.add_another")}
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </Row>
          <div className="">
            <Col md={12} className="d-flex align-items-end">
              <div className="ms-auto">
                <button
                  className="btn btn-info me-2"
                  onClick={() => {
                    setCreateField(false);
                    setContentTitle(defaultContentTitle);
                    setContentId(0);
                    // setCurrentClient({} as any);
                  }}
                >
                  {t("global.cancel")}
                </button>
                <button className="btn btn-primary" type="submit">
                  {
                    //   contentId && contentId !== 0 &&
                    showUpdate ? `${t("global.update")}` : `${t("global.add")}`
                  }
                </button>
              </div>
            </Col>
          </div>
        </Form>
      )}
    </>
  );
};
